import React, { useState } from 'react'
import Home from "../../../assets/img/icons/Home2.svg"
import arrow from "../../../assets/img/icons/Vector 2.svg"
import send from "../../../assets/img/icons/send-2.svg"
import heart from "../../../assets/img/icons/heart.svg"
import IconBox from '../../shared/IconBox'
import useFetch from '../../../hooks/useAxios'
import redheart from "../../../assets/img/icons/heartcopy.svg";
import { toast } from 'react-hot-toast'

const PlaceBreadCrumps = ({inforesidencedetail}) => {
    const [like, setlike] = useState(inforesidencedetail.wishlist)
    const apipostWishlist = useFetch({
        method: "post",
        url: `api/wishlist/${inforesidencedetail.id}`,
        noHeader: false,
        trigger: false,
        formdata: true,
        argFunc: res => {
          setlike(true);
          toast.success("این اقامتگاه با موفقیت به لیست علاقه مندی ها اضافه شد.")
        }
      });
      const apiremoveWishlist = useFetch({
        method: "delete",
        url: `api/wishlist/${inforesidencedetail.id}`,
        noHeader: false,
        trigger: false,
        formdata: true,
        argFunc: res => {
          setlike(false);
          toast.success("این اقامتگاه با موفقیت از به لیست علاقه مندی ها پاک شد.")

        }
      });
  return (
    <div className='mb-[32px] flex justify-between PlaceBreadCrumps  items-center w-full'>
        <div className='flex items-center PlaceBreadCrumps--bread'>
            <img src={Home} />
            <img className='mx-[24px]' src={arrow} />
            <p className='text-[#ABAFB4] text-[16px] font-[500]'>{
                inforesidencedetail.category === "hotel"?"هتل و مهمان پذیر":
                inforesidencedetail.category === "ecotourism_collection"?"مجموعه بوم گردی":
                inforesidencedetail.category === "villa"?"ویلایی و باغ":
                inforesidencedetail.category === "apartment"?"آپارتمانی":null

            }</p>
            <img className='mx-[24px]' src={arrow} />
            <p className='PlaceBreadCrumps-current'>استان {inforesidencedetail.city.state}</p>

        </div>
        <div className='flex items-center PlaceBreadCrumps--shared' >
            <IconBox white smallxs>
            {!like
          ? <div
              onClick={e => {
                e.stopPropagation();
                apipostWishlist.reFetch();
              }}
            >
              <img
                src={heart}
                className="transition-all transition-shadow transition-[2s]"
              />
            </div>
          : <div
              onClick={(e) =>{   e.stopPropagation(); apiremoveWishlist.reFetch()}}
            >
              <img src={redheart} />
            </div>}

            </IconBox>
            <div className='send-box mr-[16px]'>
                <img src={send} />
                <p className='mr-[8px]'>اشتراک گذاری کردن</p>

            </div>
        </div>

        
    </div>
  )
}

export default PlaceBreadCrumps